//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';
import { Placement } from 'tippy.js';
import { U } from 'ts-toolbelt';

import MultiTermHelpIcon from '@components/atoms/help-icon/MultiTermHelpIcon';
import { ITrackableComponent } from '@utils/withTracking';

interface IOwnProps
  extends React.HTMLAttributes<HTMLDivElement>,
    ITrackableComponent {
  helpText: string;
  isDisabled?: boolean;
  placement?: Placement;
}

interface IWithCtaHref extends IOwnProps {
  ctaText: string;
  ctaHref: string;
}

interface IWithCtaOnClick extends IOwnProps {
  ctaText: string;
  ctaOnClick: () => void;
}

type Props = U.Strict<IOwnProps | IWithCtaHref | IWithCtaOnClick> &
  Pick<React.ComponentProps<typeof MultiTermHelpIcon>, 'appendTarget'>;

/**
 * The HelpIcon atom renders a standardized 12x12 px help icon
 * with a standardized tooltip (help text followed by an optional CTA)
 * that appears on hover. This atom is a wrapper around MultiTermHelpIcon,
 * providing a single help term.
 */
export const HelpIcon = (props: Props) => {
  // Build a single help term using the provided props
  const helpTerms = [
    {
      ...props,
    },
  ];

  return <MultiTermHelpIcon helpTerms={helpTerms} {...props} />;
};

/**
 * This style adds a left margin of 8px. Because this style is a formal design consideration,
 * we're exporting it for the sake of consistency and usability.
 */
export const HelpIconWithMargin = styled(HelpIcon)(
  ({ theme }) => `
  margin-left: ${theme.spacings[2]};
`,
);

export default HelpIcon;
